import { Box, Dialog, DialogContent, Icon, Slide, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { type TransitionProps } from "@mui/material/transitions";
import { BiSun } from "react-icons/bi";
import { EmployeeMoodService } from "../../../services/intranet-portal-services";
import useIntranetPortalCoreApi from "../../../hooks/useIntranetPortalAdminApi";
import { toast } from "react-toastify";
import styled from "@emotion/styled";
import Doodle from "../../../../src/assets/images/mood/emojidoodle-1.png";
import { useDispatch, useSelector } from "react-redux";
import type { AppDispatch, RootState } from "../../../store/reducer";
import { handleSetMyMoodToday } from "../../utilities/auth/moooSlice";
import { runTimeConfig } from "@/config";

export const expPieData = [
  {
    value: 80,
    name: "Pass"
  },
  {
    value: 70,
    name: "Fail"
  },
  {
    value: 60,
    name: "Rock"
  },
  {
    value: 50,
    name: "Hero"
  },
  {
    value: 80,
    name: "Pass"
  },
  {
    value: 70,
    name: "Fail"
  },
  {
    value: 60,
    name: "Rock"
  },
  {
    value: 50,
    name: "Hero"
  },
  {
    value: 80,
    name: "Pass"
  },
  {
    value: 70,
    name: "Fail"
  },
  {
    value: 60,
    name: "Rock"
  },
  {
    value: 50,
    name: "Hero"
  }
];
export const expcolorsofPieChart = ["#d82d2b", "#ffc100", "#f2dada", "#222"];

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />;
});

interface moodItemsType {
  moodId: string;
  name: string;
  iconUrl: string;
  isActive: boolean;
  description: string;
  orderNumber: number;
}

interface moodCountItemsType {
  moodId: string;
  count: number;
  name: string;
  iconUrl: string;
  description: string;
}

export const EmojiBox = styled.div`
  border: 2px solid rgba(0, 0, 0, 0.08);
  padding: 10px 10px 15px 10px;
  text-align: center;
  border-radius: 3px;
  cursor: pointer;
  transition: all 0.7s ease-in-out;
  height: 100px;ss
  width: 100%;
  font-weight: 400;
  &.block {
    width: 100%;
    height: 100%;
    cursor: auto;
    /* padding-block: 2rem; */
    display: flex;
    text-align: left;
    background-color: white;
    border: none;
    cursor: auto;
    position: relative;
    z-index: 0;
    align-items: center;
    /* &:before{
      content:'';
 background:url(${Doodle}) white;
    background-size:cover;
    background-repeat: no-repeat;
    position:absolute;
    top:0;
    width:100%;
    height:100%;
    left:0;
    z-index: -1;

    } */
    img {
      /* transform:scale(1.5) */
      height: 70px;
    }
    &:hover {
      background: white;
      box-shadow: none;
      color: #616161;
      img {
        transform: none;
      }
    }
  }
  &:hover {
    box-shadow: rgba(212, 44, 44, 0.48) 0px 5px 0px 0px,
      rgba(212, 44, 44, 0.48) 0px 1px 5px 0px;
    border-color: transparent;
    background: #d42c2c;
    color: white;
    img {
      transform: scale(1.5);
    }
  }
  &.selected {
    box-shadow: rgba(212, 44, 44, 0.48) 0px 5px 0px 0px,
      rgba(212, 44, 44, 0.48) 0px 1px 5px 0px;
    border-color: transparent;
    color: white;
    background: #d42c2c;
    font-weight: 500;
    img {
      transform: scale(1.5);
    }
  }
  &.selectedEmoji {
    width: 100%;
    height: 100%;
    cursor: none;
    position: absolute;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
      transform: scale(1);
      height: auto;
    }
    h4 {
      font-size: 16px;
      line-height: 24px;
    }
    h2 {
      font-size: 30px;
      letter-spacing: 2px;
    }
  }
  img {
    height: 50px;
    transition: all 0.2s linear;
  }
  h4 {
    margin: 0;
    font-weight: inherit;
    margin-top: 5px;
  }
`;

const EmployeeMood = (): React.ReactElement => {
  const [isFirstLogin, setIsFirstLogin] = useState<boolean>(false);
  const { handleRequest, isLoading } = useIntranetPortalCoreApi();
  const [data, setData] = useState<any>();

  const [moodToday, setMoodToday] = useState<any>({});
  const [myMoodToday, setMyMoodToday] = useState<any>(null);

  const disptach: AppDispatch = useDispatch();
  const { myMoodIdValue } = useSelector((state: RootState) => state.mood);

  const getActiveMoods = async (): Promise<void> => {
    await handleRequest(() => EmployeeMoodService.getCoreApiApiAppEmployeeMoodActiveMoods()).then(
      (response) => {
        if (response != null) {
          setData(response);
        }
      }
    );
  };

  const setMoodForToday = async (selectedMoodId: string): Promise<void> => {
    if (isLoading || !!myMoodIdValue) {
      return;
    }
    const payload = { moodId: selectedMoodId };
    await handleRequest(() =>
      EmployeeMoodService.postCoreApiApiAppEmployeeMoodSetEmployeeMood(payload)
    ).then((response) => {
      if (response != null) {
        setIsFirstLogin(false);
        getMoodCountForToday();
        disptach(handleSetMyMoodToday(selectedMoodId));
        toast.success("Successfully, set today's mood", {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light"
        });
      }
    });
  };

  const getMoodCountForToday = async (): Promise<void> => {
    await handleRequest(() =>
      EmployeeMoodService.getCoreApiApiAppEmployeeMoodEmployeesMoodsCountForToday()
    ).then((response) => {
      if (response != null) {
        setMoodToday(response);
      }
    });
  };

  const getMyMoodForToday = async (): Promise<void> => {
    await handleRequest(() =>
      EmployeeMoodService.getCoreApiApiAppEmployeeMoodMyMoodForToday()
    ).then((response) => {
      if (response?.moodId) {
        setMyMoodToday(response);
      } else {
        setIsFirstLogin(true);
      }
    });
  };

  const maxCountItem =
    moodToday?.totalCount > 0
      ? moodToday.items.reduce((maxItem: moodCountItemsType, currentItem: moodCountItemsType) => {
          return currentItem.count > maxItem.count ? currentItem : maxItem;
        })
      : null;

  useEffect(() => {
    void getMyMoodForToday();
    void getActiveMoods();
    void getMoodCountForToday();
  }, []);

  const handlePopupClose = (): void => {
    if (myMoodToday != null) {
      setIsFirstLogin(false);
    } else {
      setIsFirstLogin(true);
    }
  };
  1;
  const calculatedRegisteredMood = () => {
    let highestCount = 0;
    if (moodToday?.items?.length > 0) {
      moodToday?.items?.forEach((item: any) => {
        return (highestCount += item.count);
      });
    }
    return highestCount;
  };
  const registeredMood = useMemo(calculatedRegisteredMood, [moodToday]);

  return (
    <>
      {data !== null && data?.length > 0 && myMoodToday === null ? (
        <Dialog
          PaperProps={{
            style: {
              overflow: "initial",
              minHeight: "200px",
              maxWidth: "600px",
              width: "100%"
            }
          }}
          style={{ backdropFilter: "blur(2px)" }}
          open={isFirstLogin}
          onClose={handlePopupClose}
          TransitionComponent={Transition}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent dividers={true}>
            <Box marginBottom="1.5rem">
              <Typography variant="h6">How are you feeling today ?</Typography>
            </Box>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill,minmax(110px,1fr))",
                gap: 1,
                width: "100%",
                height: "50%"
              }}
            >
              {data.map((item: moodItemsType) => (
                <EmojiBox
                  key={item.moodId}
                  onClick={() => {
                    void setMoodForToday(item.moodId);
                  }}
                >
                  <img
                    src={`${runTimeConfig.VITE_BASE_URL}/core-api/Mood-logos/file/${item.moodId}`}
                    alt=""
                  />
                  <h4> {item.name}</h4>
                </EmojiBox>
              ))}
            </Box>
          </DialogContent>
        </Dialog>
      ) : null}

      <Box>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "400",
            mb: "0.5rem",
            display: "flex",
            lineHeight: "32px"
          }}
        >
          <Icon color="primary" sx={{ mr: "8px" }}>
            <BiSun size="2rem" />
          </Icon>
          {`Current vibes in the AMNIVERSE (${maxCountItem?.count ?? "0"}/${registeredMood})`}
        </Typography>

        {maxCountItem !== null ? (
          <EmojiBox className="block">
            <img
              src={`${
                runTimeConfig.VITE_BASE_URL
              }/core-api/Mood-logos/file/${maxCountItem?.moodId as string}`}
              alt=""
            />
            <Typography sx={{ fontWeight: "500" }}>{maxCountItem?.description}</Typography>
            {/* <Box sx={{ height: 50, width: 100, background: "red" }}>
              <ResponsiveContainer>
                <PieChart>
                  <Pie
                    dataKey="value"
                    data={expPieData}
                    innerRadius={8}
                    outerRadius={25}
                    cy={20}
                  >
                    {expPieData.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={
                          expcolorsofPieChart[
                            index % expcolorsofPieChart.length
                          ]
                        }
                      />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            </Box> */}
          </EmojiBox>
        ) : (
          <Typography>No mood data available for today.</Typography>
        )}
      </Box>
    </>
  );
};

export default EmployeeMood;
